module.exports = __webpack_public_path__ + "static/DarksideDetective1-be596e5e86dd473ce8610bc4cd89a9d7.webp";